export enum Language {
    en = "english",
    fi = "finnish",
    se = "swedish",
}

export enum TranslationKeys {
    selectLanguage = "selectLanguage",
    selectVisitSubject = "selectVisitSubject",
    selectCustomerType = "selectCustomerType",
    selectService = "selectService",
    selectSubService = "selectSubService",
    selectDistrict = "selectDistrict",
    selectPremise = "selectPremise",
    selectExpert = "selectExpert",
    summary = "summary",
    selectTime = "selectTime",
    service = "service",
    time = "time",
    duration = "duration",
    city = "city",
    address = "address",
    confirm = "confirm",
    selfPaying = "selfPaying",
    GEselfPaying = "GEselfPaying",
    serviceVoucher = "serviceVoucher",
    GEserviceVoucher = "GEserviceVoucher",
    purchaseService = "purchaseService",
    monday = "monday",
    tuesday = "tuesday",
    wednesday = "wednesday",
    thursday = "thursday",
    friday = "friday",
    saturday = "saturday",
    sunday = "sunday",
    stepperReserveTimeslot = "stepperReserveTimeslot",
    stepperIdentification = "stepperIdentification",
    stepperInformationForm = "stepperInformationForm",
    stepperInformationFormOther = "stepperInformationFormOther",
    stepperConfirm = "stepperConfirm",
    clock = "clock",
    price = "price",
    loginToMyCoronaria = "loginToMyCoronaria",
    personalIdentificationNumber = "personalIdentificationNumber",
    personalIdentificationNumberOther = "personalIdentificationNumberOther",
    firstName = "firstName",
    firstNameOther = "firstNameOther",
    lastName = "lastName",
    lastNameOther = "lastNameOther",
    postalCode = "postalCode",
    postalCodeOther = "postalCodeOther",
    district = "district",
    districtOther = "districtOther",
    phoneNumber = "phoneNumber",
    phoneNumberOther = "phoneNumberOther",
    email = "email",
    emailOther = "emailOther",
    iDontHaveEmail = "iDontHaveEmail",
    moreInformation = "moreInformation",
    moreInformationMax300 = "moreInformationMax300",
    buttonGoBack = "buttonGoBack",
    buttonNext = "buttonNext",
    buttonAbort = "buttonAbort",
    buttonConfirm = "buttonConfirm",
    howToRemind = "howToRemind",
    withEmail = "withEmail",
    withTextMessage = "withTextMessage",
    chooseReminderTime = "chooseReminderTime",
    oneDayBefore = "oneDayBefore",
    twoHoursBefore = "twoHoursBefore",
    dataProtectionAndMarketing = "dataProtectionAndMarketing",
    checkboxDataProtectionAgree = "checkboxDataProtectionAgree",
    checkboxMarketingPermission = "checkboxMarketingPermission",
    appointmentSuccessfull = "appointmentSuccesfull",
    buttonSaveToCalendar = "buttonSaveToCalendar",
    buttonPrint = "buttonPrint",
    buttonReturnToFrontPage = "buttonReturnToFrontPage",
    buttonClose = "buttonClose",
    confirmationFormLongFooterHeader = "confirmationFormLongFooterHeader",
    confirmationFormLongFooterText1 = "confirmationFormLongFooterText1",
    confirmationFormLongFooterText2 = "confirmationFormLongFooterText2",
    confirmationFormShortFooterText = "confirmationFormShortFooterText",
    confirmationFormShortFooterText2 = "confirmationFormShortFooterText2",
    specialty = "specialty",
    education = "education",
    languageSkills = "languageSkills",
    expertsPremises = "expertsPremises",
    priceList = "priceList",
    reserveTimeslot = "reserveTimeslot",
    closeOrMoveBack = "closeOrMoveBack",
    reservationService = "reservationService",
    location = "location",
    writeYourLocation = "writeYourLocation",
    locate = "locate",
    gettingLocation = "gettingLocation",
    preferCalling = "preferCalling",
    youCanCallUs = "youCanCallUs",
    morning = "morning",
    dayTime = "dayTime",
    afternoon = "afternoon",
    evening = "evening",
    nextFreeTimeslots = "nextFreeTimeslots",
    noTimesAvailable = "noTimesAvailable",
    searchExpert = "searchExpert",
    searchService = "searchService",
    timeslotConfirmationFailureHeader = "timeslotConfirmationFailureHeader",
    timeslotConfirmationFailureMiddle = "timeslotConfirmationFailureMiddle",
    timeslotConfirmationFailureText = "timeslotConfirmationFailureText",
    patientVerificationFailureMiddle = "patientVerificationFailureMiddle",
    patientVerificationFailureText = "patientVerificationFailureText",
    closeAndSelectNewTimeslot = "closeAndSelectNewTimeslot",
    patientVerificationFailureTryAgain = "patientVerificationFailureTryAgain",
    ssnError = "ssnError",
    ssnTooltip = "ssnTooltip",
    emailError = "emailError",
    phoneError = "phoneError",
    postalError = "postalError",
    lengthError = "lengthError",
    ssnMismatchTitle = "ssnMismatchTitle",
    ssnMismatchMessage = "ssnMismatchMessage",
    ssnMismatchOkButton = "ssnMismatchOkButton",
    sessionExpiredTitle = "sessionExpiredTitle",
    sessionExpiredMessage = "sessionExpiredMessage",
    sessionExpiredOkButton = "sessionExpiredOkButton",
    localityValidationError = "localityValidationError",
    continueToNextPhase = "continueToNextPhase",
    errorNotFoundHeader = "errorNotFoundHeader",
    errorNotFoundText = "errorNotFoundText",
    errorMaintenanceHeader = "errorMaintenanceHeader",
    errorAlternateHeader = "errorAlternateHeader",
    errorMaintenanceText = "errorMaintenanceText",
    errorSomethingWentWrongHeader = "errorSomethingWentWrongHeader",
    errorSomethingWentWrongFirstParagraph = "errorSomethingWentWrongFirstParagraph",
    errorSomethingWentWrongSecondParagraph = "errorSomethingWentWrongSecondParagraph",
    loading = "loading",
    addressSpecifier = "addressSpecifier",
    selectStreet = "selectStreet",
    searchForStreetBy = "searchForStreetBy",
    selectPostalRegion = "selectPostalRegion",
    selectSpecificAddress = "selectSpecificAddress",
    ariaLabelSelectCustomerTypeRadio = "ariaLabelSelectCustomerTypeRadio",
    thisDay = "thisDay",
    chosenDate = "chosenDate",
    timesFree = "timesFree",
    showExtraFilters = "showExtraFilters",
    hideExtraFilters = "hideExtraFilters",
    searchSpeciality = "searchSpeciality",
    speciality = "speciality",
    expertLanguage = "expertLanguage",
    chooose = "choose",
    expertCustomers = "expertCustomers",
    customers = "customers",
    reservingTimeslot = "reservingTimeslot",
    stairAndOrUnitInformation = "stairAndOrUnitInformation",
    errorTryAgain = "errorTryAgain",
    cancelReservationHeader = "cancelReservationHeader",
    cancelReservationCancelWithPinHeader = "cancelReservationCancelWithPinHeader",
    cancelReservationCancelByPhone = "cancelReservationCancelByPhone",
    cancelReservationCancellingReservedTimeHeader = "cancelReservationCancellingReservedTimeHeader",
    cancelReservationDisclaimerParagraph1 = "cancelReservationDisclaimerParagraph1",
    cancelReservationDisclaimerParagraph2 = "cancelReservationDisclaimerParagraph2",
    temporaryCancelReservationDisclaimer = "temporaryCancelReservationDisclaimer",
    cancelSuccessButton = "cancelSuccessButton",
    cancelGenericFailButton = "cancelGenericFailButton",
    pinCode = "pinCode",
    ssn = "ssn",
    cancelReservationButton = "cancelReservationButton",
    sendingCancellationRequest = "sendingCancellationRequest",
    cancellationErrorDefault = "cancellationErrorDefault",
    cancellationError = "cancellationError",
    cancellationSuccess = "cancellationSuccess",
    cancelReservationPinDisclaimer = "cancelReservationPinDisclaimer",
    cancelReservationSSNDisclaimer = "cancelReservationSSNDisclaimer",
    services = "services",
    others = "others",
    premiseOrMunicipality = "premiseOrMunicipality",
    searchForPremiseOrMunicipality = "searchForPremiseOrMunicipality",
    invalidUUIDError = "invalidUUIDError",
    reservationTooCloseError = "reservationTooCloseError",
    cancellationGenericError = "cancellationGenericError",
    showMore = "showMore",
    distance = "distance",
    fromLocation = "fromLocation",
    toAddress = "toAddress",
    oclock = "oclock",
    expertProfile = "expertProfile",
    paymentMethod = "paymentMethod",
    selectDay = "selectDay",
    day = "day",
    all = "all",
    reserveTimeByPhone = "reserveTimeByPhone",
    openTimes = "openTimes",
    callPrice = "callPrice",
    informationWillOnlyBeAvailableTo = "informationWillOnlyBeAvailableTo",
    agreeToDataPrivacyHeader = "agreeToDataPrivacyHeader",
    verifySelection = "verifySelection",
    verifySelectionOther = "verifySelectionOther",
    arrival = "arrival",
    showMoreArrivalTips = "showMoreArrivalTips",
    showLessArrivalTips = "showLessArrivalTips",
    summaryOfReservation = "summaryOfReservation",
    arrivalWithOwnCar = "arrivalWithOwnCar",
    accessibility = "accessibility",
    parking = "parking",
    showNextMonth = "showNextMonth",
    showPreviousMonth = "showPreviousMonth",
    showNextDay = "showNextDay",
    showPreviousDay = "showPreviousDay",
    ariaLabelFilterMenu = "ariaLabelFilterMenu",
    loadingPremises = "loadingPremises",
    loadingExperts = "loadingExperts",
    searchingLocationHelper = "searchingLocationHelper",
    premisesNearYou = "premisesNearYou",
    cancelLocationSearch = "cancelLocationSearch",
    orderByTime = "orderByTime",
    orderByDistance = "orderByDistance",
    streetAddress = "streetAddress",
    streetAddressOther = "streetAddressOther",
    readOurPrivacyPolicyHere = "readOurPrivacyPolicyHere",
    sendSummaryOfReservation = "sendSummaryOfReservation",
    summaryOfForm = "summaryOfForm",
    iWantAReminderWithTextMessage = "iWantAReminderWithTextMessage",
    listOfPrices = "listOfPrices",
    listOfPricesDisclaimer = "listOfPricesDisclaimer",
    listOfPricesLink = "listOfPricesLink",
    popular = "popular",
    serviceVoucherNumber = "serviceVoucherNumber",
    discountCodeNumber = "discountCodeNumber",
    discountCodeNumberInfo = "discountCodeNumberInfo",
    paymentVoucher = "paymentVoucher",
    GEpaymentVoucher = "GEpaymentVoucher",
    errorContactLinkText = "errorContactLinkText",
    kuntoutusErrorContactText = "kuntoutusErrorContactText",
    reservationProblem = "reservationProblem",
    reservationConfirmationTimeout = "reservationConfirmationTimeout",
    reservationConfirmationTimeoutText = "reservationConfirmationTimeoutText",
    reservationConfirmationTimeoutPointOne = "reservationConfirmationTimeoutPointOne",
    reservationConfirmationTimeoutPointTwo = "reservationConfirmationTimeoutPointTwo",
    reservationConfirmationTimeoutEnd = "reservationConfirmationTimeoutEnd",
    infoAndPrice = "infoAndPrice",
    nextDay = "nextDay",
    previousDay = "previousDay",
    chooseCustomerType = "chooseCustomerType",
    ifPayingYourself = "ifPayingYourself",
    chooseAsCustomerType = "chooseAsCustomerType",
    weHaveKelasPayment = "weHaveKelasPayment",
    serviceVoucherCustomers = "serviceVoucherCustomers",
    purchaseServiceCustomer = "purchaseServiceCustomer",
    cityOfHelsinki = "cityOfHelsinki",
    cityOfKerava = "cityOfKerava",
    cityOfTampere = "cityOfTampere",
    karviainens = "karviainens",
    jyvaskylas = "jyvaskylas",
    cityOfEspoo = "cityOfEspoo",
    infoReminder = "infoReminder",
    ythsCustomers = "ythsCustomers",
    ythsInfo = "ythsInfo",
    tampereInfo = "tampereInfo",
    byPhone = "byPhone",
    howToChooseCustomerType = "howToChooseCustomerType",
    serviceVoucherUsedFor = "serviceVoucherUsedFor",
    helsinkiAndUusimaa = "helsinkiAndUusimaa",
    tampereArea = "tampereArea",
    paidByInsurance = "paidByInsurance",
    hus = "hus",
    ifUsingServiceVoucher = "ifUsingServiceVoucher",
    emptyTimeselectItem = "emptyTimeselectItem",
    endoscopyCustomerTypeTooltip = "endoscopyCustomerTypeTooltip",
    remoteReception = "remoteReception",
    sleepClinic = "sleepClinic",
    koho = "koho",
    kohoClarification = "kohoClarification",
    reservationOnly = "reservationOnly",
    endoscopyClinicNote = "endoscopyClinicNote",
    attention = "attention",
    limitedInternetReservationNote = "limitedInternetReservationNote",
    limitedInternetBookingDetails = "limitedInternetBookingDetails",
    limitedInternetBookingTitle = "limitedInternetBookingTitle",
    limitedInternetReservationNote2 = "limitedInternetReservationNote2",
    limitedInternetBookingDetails2 = "limitedInternetBookingDetails2",
    limitedInternetBookingTitle2 = "limitedInternetBookingTitle2",
    remoteBookingInfoNote = "remoteBookingInfoNote",
    remoteBookingInfoDetails = "remoteBookingInfoDetails",
    remoteBookingInfoTitle = "remoteBookingInfoTitle",
    bookingRequiresIdentification = "bookingRequiresIdentification",
    bookingIsAvailableByPhone = "bookingIsAvailableByPhone",
    bookTimeForMyself = "bookTimeForMyself",
    bookTimeForSomeoneElse = "bookTimeForSomeoneElse",
    bookTimeByPhone = "bookTimeByPhone",
    phoneReservationDialogTitle = "phoneReservationDialogTitle",
    phoneReservationCompanyName = "phoneReservationCompanyName",
    phoneReservationPhoneNumber = "phoneReservationPhoneNumber",
    phoneReservationServiceHours = "phoneReservationServiceHours",
    authenticateBeforeBooking = "authenticateBeforeBooking",
    reserverName = "reserverName",
    yourAreAboutToBookTime = "yourAreAboutToBookTime",
    authenticationInterrupedTitle = "authenticationInterrupedTitle",
    authenticationInterruptedByUser = "authenticationInterruptedByUser",
    authenticationTimeout = "authenticationTimeout",
    authenticationParameterError = "authenticationParameterError",
    authenticationUnknowError = "authenticationUnknowError",
    authenticationIssueConfirm = "authenticationIssueConfirm"
}

export type Translation = {
    [index: string]: string,
    [TranslationKeys.selectLanguage]: string,
    [TranslationKeys.selectVisitSubject]: string,
    [TranslationKeys.selectCustomerType]: string,
    [TranslationKeys.selectService]: string,
    [TranslationKeys.selectSubService]: string,
    [TranslationKeys.selectDistrict]: string,
    [TranslationKeys.selectPremise]: string,
    [TranslationKeys.selectExpert]: string,
    [TranslationKeys.summary]: string,
    [TranslationKeys.selectTime]: string,
    [TranslationKeys.service]: string,
    [TranslationKeys.time]: string,
    [TranslationKeys.duration]: string,
    [TranslationKeys.city]: string,
    [TranslationKeys.address]: string,
    [TranslationKeys.confirm]: string,
    [TranslationKeys.selfPaying]: string,
    [TranslationKeys.serviceVoucher]: string,
    [TranslationKeys.purchaseService]: string,
    [TranslationKeys.monday]: string,
    [TranslationKeys.tuesday]: string,
    [TranslationKeys.wednesday]: string,
    [TranslationKeys.thursday]: string,
    [TranslationKeys.friday]: string,
    [TranslationKeys.saturday]: string,
    [TranslationKeys.sunday]: string,
    [TranslationKeys.stepperReserveTimeslot]: string,
    [TranslationKeys.stepperIdentification]: string,
    [TranslationKeys.stepperInformationForm]: string,
    [TranslationKeys.stepperInformationFormOther]: string,
    [TranslationKeys.stepperConfirm]: string,
    [TranslationKeys.clock]: string,
    [TranslationKeys.price]: string,
    [TranslationKeys.loginToMyCoronaria]: string,
    [TranslationKeys.personalIdentificationNumber]: string,
    [TranslationKeys.personalIdentificationNumberOther]: string,
    [TranslationKeys.firstName]: string,
    [TranslationKeys.firstNameOther]: string,
    [TranslationKeys.lastName]: string,
    [TranslationKeys.lastNameOther]: string,
    [TranslationKeys.postalCode]: string,
    [TranslationKeys.postalCodeOther]: string,
    [TranslationKeys.district]: string,
    [TranslationKeys.districtOther]: string,
    [TranslationKeys.phoneNumber]: string,
    [TranslationKeys.phoneNumberOther]: string,
    [TranslationKeys.email]: string,
    [TranslationKeys.emailOther]: string,
    [TranslationKeys.iDontHaveEmail]: string,
    [TranslationKeys.moreInformation]: string,
    [TranslationKeys.moreInformationMax300]: string,
    [TranslationKeys.buttonGoBack]: string,
    [TranslationKeys.buttonNext]: string,
    [TranslationKeys.buttonAbort]: string,
    [TranslationKeys.buttonConfirm]: string,
    [TranslationKeys.howToRemind]: string,
    [TranslationKeys.withEmail]: string,
    [TranslationKeys.withTextMessage]: string,
    [TranslationKeys.chooseReminderTime]: string,
    [TranslationKeys.oneDayBefore]: string,
    [TranslationKeys.twoHoursBefore]: string,
    [TranslationKeys.dataProtectionAndMarketing]: string,
    [TranslationKeys.checkboxDataProtectionAgree]: string,
    [TranslationKeys.checkboxMarketingPermission]: string,
    [TranslationKeys.appointmentSuccessfull]: string,
    [TranslationKeys.buttonSaveToCalendar]: string,
    [TranslationKeys.buttonPrint]: string,
    [TranslationKeys.buttonReturnToFrontPage]: string,
    [TranslationKeys.buttonClose]: string,
    [TranslationKeys.confirmationFormLongFooterHeader]: string,
    [TranslationKeys.confirmationFormLongFooterText1]: string,
    [TranslationKeys.confirmationFormLongFooterText2]: string,
    [TranslationKeys.confirmationFormShortFooterText]: string,
    [TranslationKeys.confirmationFormShortFooterText2]: string,
    [TranslationKeys.specialty]: string,
    [TranslationKeys.education]: string,
    [TranslationKeys.languageSkills]: string,
    [TranslationKeys.expertsPremises]: string,
    [TranslationKeys.priceList]: string,
    [TranslationKeys.reserveTimeslot]: string,
    [TranslationKeys.closeOrMoveBack]: string,
    [TranslationKeys.reservationService]: string,
    [TranslationKeys.location]: string,
    [TranslationKeys.writeYourLocation]: string,
    [TranslationKeys.locate]: string,
    [TranslationKeys.gettingLocation]: string,
    [TranslationKeys.preferCalling]: string,
    [TranslationKeys.youCanCallUs]: string,
    [TranslationKeys.morning]: string,
    [TranslationKeys.dayTime]: string,
    [TranslationKeys.afternoon]: string,
    [TranslationKeys.evening]: string,
    [TranslationKeys.nextFreeTimeslots]: string,
    [TranslationKeys.noTimesAvailable]: string,
    [TranslationKeys.searchExpert]: string,
    [TranslationKeys.searchService]: string,
    [TranslationKeys.timeslotConfirmationFailureHeader]: string,
    [TranslationKeys.timeslotConfirmationFailureMiddle]: string,
    [TranslationKeys.timeslotConfirmationFailureText]: string,
    [TranslationKeys.closeAndSelectNewTimeslot]: string,
    [TranslationKeys.ssnError]: string,
    [TranslationKeys.ssnTooltip]: string,
    [TranslationKeys.emailError]: string,
    [TranslationKeys.phoneError]: string,
    [TranslationKeys.continueToNextPhase]: string,
    [TranslationKeys.errorNotFoundHeader]: string,
    [TranslationKeys.errorNotFoundText]: string,
    [TranslationKeys.errorMaintenanceHeader]: string,
    [TranslationKeys.errorMaintenanceText]: string,
    [TranslationKeys.errorSomethingWentWrongHeader]: string,
    [TranslationKeys.errorSomethingWentWrongFirstParagraph]: string,
    [TranslationKeys.errorSomethingWentWrongSecondParagraph]: string,
    [TranslationKeys.stairAndOrUnitInformation]: string,
    [TranslationKeys.errorTryAgain]: string,
    [TranslationKeys.loading]: string,
    [TranslationKeys.addressSpecifier]: string,
    [TranslationKeys.selectStreet]: string,
    [TranslationKeys.searchForStreetBy]: string,
    [TranslationKeys.selectPostalRegion]: string,
    [TranslationKeys.selectSpecificAddress]: string,
    [TranslationKeys.ariaLabelSelectCustomerTypeRadio]: string,
    [TranslationKeys.thisDay]: string,
    [TranslationKeys.chosenDate]: string,
    [TranslationKeys.timesFree]: string,
    [TranslationKeys.showExtraFilters]: string,
    [TranslationKeys.hideExtraFilters]: string,
    [TranslationKeys.speciality]: string,
    [TranslationKeys.searchSpeciality]: string,
    [TranslationKeys.expertLanguage]: string,
    [TranslationKeys.chooose]: string,
    [TranslationKeys.expertCustomers]: string,
    [TranslationKeys.customers]: string,
    [TranslationKeys.reservingTimeslot]: string,
    [TranslationKeys.reservingTimeslot]: string,
    [TranslationKeys.stairAndOrUnitInformation]: string,
    [TranslationKeys.cancelReservationHeader]: string,
    [TranslationKeys.pinCode]: string,
    [TranslationKeys.cancelReservationButton]: string,
    [TranslationKeys.sendingCancellationRequest]: string,
    [TranslationKeys.cancellationError]: string,
    [TranslationKeys.cancellationSuccess]: string,
    [TranslationKeys.services]: string,
    [TranslationKeys.others]: string,
    [TranslationKeys.premiseOrMunicipality]: string,
    [TranslationKeys.searchForPremiseOrMunicipality]: string,
    [TranslationKeys.invalidUUIDError]: string,
    [TranslationKeys.reservationTooCloseError]: string,
    [TranslationKeys.showMore]: string,
    [TranslationKeys.distance]: string,
    [TranslationKeys.fromLocation]: string,
    [TranslationKeys.toAddress]: string,
    [TranslationKeys.oclock]: string,
    [TranslationKeys.expertProfile]: string,
    [TranslationKeys.paymentMethod]: string,
    [TranslationKeys.selectDay]: string,
    [TranslationKeys.day]: string,
    [TranslationKeys.all]: string,
    [TranslationKeys.reserveTimeByPhone]: string,
    [TranslationKeys.openTimes]: string,
    [TranslationKeys.callPrice]: string,
    [TranslationKeys.informationWillOnlyBeAvailableTo]: string,
    [TranslationKeys.agreeToDataPrivacyHeader]: string,
    [TranslationKeys.verifySelection]: string,
    [TranslationKeys.verifySelectionOther]: string,
    [TranslationKeys.arrival]: string,
    [TranslationKeys.showMoreArrivalTips]: string,
    [TranslationKeys.showLessArrivalTips]: string,
    [TranslationKeys.summaryOfReservation]: string,
    [TranslationKeys.arrivalWithOwnCar]: string,
    [TranslationKeys.accessibility]: string,
    [TranslationKeys.parking]: string,
    [TranslationKeys.cancelReservationCancelWithPinHeader]: string,
    [TranslationKeys.cancelReservationCancellingReservedTimeHeader]: string,
    [TranslationKeys.cancelReservationDisclaimerParagraph1]: string,
    [TranslationKeys.cancelReservationDisclaimerParagraph2]: string,
    [TranslationKeys.cancelReservationPinDisclaimer]: string,
    [TranslationKeys.cancelSuccessButton]: string,
    [TranslationKeys.cancellationGenericError]: string,
    [TranslationKeys.showNextMonth]: string,
    [TranslationKeys.showPreviousMonth]: string,
    [TranslationKeys.showNextDay]: string,
    [TranslationKeys.showPreviousDay]: string,
    [TranslationKeys.ariaLabelFilterMenu]: string,
    [TranslationKeys.loadingPremises]: string,
    [TranslationKeys.loadingExperts]: string,
    [TranslationKeys.searchingLocationHelper]: string,
    [TranslationKeys.premisesNearYou]: string,
    [TranslationKeys.cancelLocationSearch]: string,
    [TranslationKeys.orderByTime]: string,
    [TranslationKeys.orderByDistance]: string,
    [TranslationKeys.streetAddress]: string,
    [TranslationKeys.streetAddressOther]: string,
    [TranslationKeys.postalError]: string,
    [TranslationKeys.lengthError]: string,
    [TranslationKeys.ssnMismatchTitle]: string,
    [TranslationKeys.ssnMismatchMessage]: string,
    [TranslationKeys.ssnMismatchOkButton]: string,
    [TranslationKeys.sessionExpiredTitle]: string,
    [TranslationKeys.sessionExpiredMessage]: string,
    [TranslationKeys.sessionExpiredOkButton]: string,
    [TranslationKeys.readOurPrivacyPolicyHere]: string,
    [TranslationKeys.sendSummaryOfReservation]: string,
    [TranslationKeys.summaryOfForm]: string,
    [TranslationKeys.iWantAReminderWithTextMessage]: string,
    [TranslationKeys.listOfPrices]: string,
    [TranslationKeys.listOfPricesDisclaimer]: string,
    [TranslationKeys.listOfPricesLink]: string,
    [TranslationKeys.popular]: string,
    [TranslationKeys.serviceVoucherNumber]: string,
    [TranslationKeys.discountCodeNumber]: string,
    [TranslationKeys.discountCodeNumberInfo]: string,
    [TranslationKeys.paymentVoucher]: string,
    [TranslationKeys.GEpaymentVoucher]: string,
    [TranslationKeys.GEserviceVoucher]: string,
    [TranslationKeys.GEselfPaying]: string,
    [TranslationKeys.errorContactLinkText]: string,
    [TranslationKeys.errorAlternateHeader]: string,
    [TranslationKeys.reservationProblem]: string,
    [TranslationKeys.reservationConfirmationTimeout]: string,
    [TranslationKeys.reservationConfirmationTimeoutText]: string,
    [TranslationKeys.reservationConfirmationTimeoutPointOne]: string,
    [TranslationKeys.reservationConfirmationTimeoutPointTwo]: string,
    [TranslationKeys.reservationConfirmationTimeoutEnd]: string,
    [TranslationKeys.infoAndPrice]: string,
    [TranslationKeys.nextDay]: string,
    [TranslationKeys.previousDay]: string,
    [TranslationKeys.chooseCustomerType]: string,
    [TranslationKeys.ifPayingYourself]: string,
    [TranslationKeys.chooseAsCustomerType]: string,
    [TranslationKeys.weHaveKelasPayment]: string,
    [TranslationKeys.serviceVoucherCustomers]: string,
    [TranslationKeys.purchaseServiceCustomer]: string,
    [TranslationKeys.cityOfHelsinki]: string,
    [TranslationKeys.cityOfKerava]: string,
    [TranslationKeys.cityOfTampere]: string,
    [TranslationKeys.karviainens]: string,
    [TranslationKeys.cityOfEspoo]: string,
    [TranslationKeys.infoReminder]: string,
    [TranslationKeys.ythsCustomers]: string,
    [TranslationKeys.ythsInfo]: string,
    [TranslationKeys.tampereInfo]: string,
    [TranslationKeys.byPhone]: string,
    [TranslationKeys.howToChooseCustomerType]: string,
    [TranslationKeys.serviceVoucherUsedFor]: string,
    [TranslationKeys.helsinkiAndUusimaa]: string,
    [TranslationKeys.tampereArea]: string,
    [TranslationKeys.paidByInsurance]: string,
    [TranslationKeys.hus]: string,
    [TranslationKeys.ifUsingServiceVoucher]: string,
    [TranslationKeys.emptyTimeselectItem]: string,
    [TranslationKeys.remoteReception]: string,
    [TranslationKeys.koho]: string,
    [TranslationKeys.kohoClarification]: string,
    [TranslationKeys.reservationOnly]: string,
    [TranslationKeys.endoscopyCustomerTypeTooltip]: string,
    [TranslationKeys.remoteReception]: string,
    [TranslationKeys.sleepClinic]: string,
    [TranslationKeys.endoscopyClinicNote]: string,
    [TranslationKeys.attention]: string,
    [TranslationKeys.limitedInternetReservationNote]: string,
    [TranslationKeys.limitedInternetBookingDetails]: string,
    [TranslationKeys.limitedInternetBookingTitle]: string,
    [TranslationKeys.limitedInternetReservationNote2]: string,
    [TranslationKeys.limitedInternetBookingDetails2]: string,
    [TranslationKeys.limitedInternetBookingTitle2]: string,
    [TranslationKeys.remoteBookingInfoNote]: string,
    [TranslationKeys.remoteBookingInfoDetails]: string,
    [TranslationKeys.remoteBookingInfoTitle]: string,
    [TranslationKeys.bookingRequiresIdentification]: string,
    [TranslationKeys.bookingIsAvailableByPhone]: string,
    [TranslationKeys.bookTimeForMyself]: string,
    [TranslationKeys.bookTimeForSomeoneElse]: string,
    [TranslationKeys.bookTimeByPhone]: string,
    [TranslationKeys.phoneReservationDialogTitle]: string,
    [TranslationKeys.phoneReservationCompanyName]: string,
    [TranslationKeys.phoneReservationPhoneNumber]: string,
    [TranslationKeys.phoneReservationServiceHours]: string,
    [TranslationKeys.authenticateBeforeBooking]: string,
    [TranslationKeys.reserverName]: string,
    [TranslationKeys.yourAreAboutToBookTime]: string,
    [TranslationKeys.authenticationInterrupedTitle]: string,
    [TranslationKeys.authenticationInterruptedByUser]: string,
    [TranslationKeys.authenticationTimeout]: string,
    [TranslationKeys.authenticationParameterError]: string,
    [TranslationKeys.authenticationUnknowError]: string,
    [TranslationKeys.authenticationIssueConfirm]: string
};

export interface ITranslationLanguages {
    [Language.en]: Translation,
    [Language.fi]: Translation,
    [Language.se]: Translation
}
